import { DEVICE_BREAKPOINTS } from '@/constants/breakpoints'

export const useSidebarStore = defineStore('sidebar', {
  state() {
    return {
      active: true,
      windowWidth: typeof window !== 'undefined' ? window.innerWidth : DEVICE_BREAKPOINTS.DESKTOP,
    }
  },
  getters: {
    isActive(state) {
      return state.active
    },
    responsiveActive(state) {
      return state.active && state.windowWidth > DEVICE_BREAKPOINTS.DESKTOP
    },
  },
  actions: {
    toggleSidebar() {
      this.active = !this.isActive
    },
    updateWindowWidth() {
      this.windowWidth = window.innerWidth
    },
  },
})
